import { useEffect, useState } from "react";
import axios from "axios";
import { Controller, Discord, HeartFill } from "react-bootstrap-icons";
import CustomButton from "../CustomButton";
import Install from "../Install";
import ModeList from "../ModeList";
import "./landing.css";

export default function Landing() {
    const [playerCount, setPlayerCount] = useState<string | null>(null);
    const [playerCountError, setPlayerCountError] = useState(false);

    useEffect(() => {
        axios
            .get("https://play.skeld.net/api/playercount")
            .then((response: any) => {
                setPlayerCount(response.data);
            })
            .catch(() => {
                setPlayerCountError(true);
            });
    }, []);

    return (
        <div>
            <div className="panel hero text-center">
                <h1 className="hero-title">skeld.net</h1>
                <p className="lead-text mb-3">
                    The world's only free-to-play public modded Among Us server.
                </p>
                <div className="player-count-badge mb-4">
                    <span
                        className={`player-count-dot ${
                            playerCount ? "is-live" : ""
                        }`}
                    />
                    {playerCount
                        ? `${playerCount} playing now`
                        : playerCountError
                        ? "Server status unavailable"
                        : "Checking server..."}
                </div>
                <div className="d-flex flex-wrap justify-content-center">
                    <CustomButton to="/codes" icon={Controller}>
                        Lobby Browser
                    </CustomButton>
                    <CustomButton
                        to="https://discord.gg/B2Cj6usFBa"
                        icon={Discord}
                    >
                        Discord
                    </CustomButton>
                    <CustomButton
                        to="https://www.patreon.com/skeld_net"
                        icon={HeartFill}
                    >
                        Patreon
                    </CustomButton>
                </div>
            </div>

            <section className="section">
                <h2 className="section-heading">What is this?</h2>
                <div className="panel">
                    <article className="mb-0">
                        <p className="mb-0">
                            Skeld.net is the world's ONLY free-to-play public
                            modded Among Us server. Run by Arkatme and his
                            amazing support staff, Skeld.net offers you
                            endless hours of extra enjoyment if you have
                            gotten bored of vanilla Among Us gameplay.
                        </p>
                    </article>
                </div>
            </section>

            <section className="section">
                <Install />
            </section>

            <section className="section">
                <h2 className="section-heading">Watch the trailer</h2>
                <div className="panel video-panel">
                    <div className="video-embed">
                        <iframe
                            src="https://www.youtube.com/embed/1LpKGswpthk"
                            title="Skeld.net trailer"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            loading="lazy"
                        />
                    </div>
                </div>
            </section>

            <section className="section">
                <ModeList />
            </section>
        </div>
    );
}
